/**
 * Frontend HTTP status layer: normalizes API responses by status code.
 * Use for new APIs that return proper HTTP status (200, 400, 404, 500).
 * Returns { success, statusCode, data } so callers can branch on status without reshaping body.
 */

export async function requestWithStatusHandling(apiClient, config) {
  try {
    const response = await apiClient.request(config);
    return {
      success: true,
      statusCode: 200,
      data: response,
    };
  } catch (error) {
    const statusCode = error?.response?.status ?? 500;
    const data = error?.response?.data ?? null;
    return {
      success: false,
      statusCode,
      data,
      errorMessage: error?.message ?? null,
    };
  }
}
